import React from 'react';
import { Train, Plane, Bus, MapPin } from 'lucide-react';
import PageHero, { Section, InfoCard, CTABlock } from '../components/PageHero';

const cities = [
  { city: 'Kazan', modes: 'Domestic flight (1h 40m) or Sapsan train (11h)', tips: 'Direct flights daily from Moscow SVO. Trains overnight.' },
  { city: 'Volgograd', modes: 'Domestic flight (1h 45m) or overnight train (16h)', tips: 'Aeroflot & S7 daily flights. Train saves on hostel first night.' },
  { city: 'Kursk', modes: 'High-speed train (7h) or overnight sleeper (10h)', tips: 'No direct flights. Take train from Moscow Kursky station.' },
  { city: 'Ufa (BSMU)', modes: 'Domestic flight (2h) or Trans-Siberian train (25h)', tips: 'Flight recommended. Trans-Siberian is a lifetime experience if you have time.' },
  { city: 'Saint Petersburg', modes: 'Sapsan high-speed train (4h) or flight (1h 30m)', tips: 'Sapsan train is more scenic and often cheaper.' },
  { city: 'Rostov-on-Don', modes: 'Domestic flight (2h) or train (17h)', tips: 'Southern city, warmer climate. Flight is quickest.' },
  { city: 'Novosibirsk', modes: 'Domestic flight (4h) or Trans-Siberian train (48h)', tips: 'Only fly. Train is only for adventure seekers.' },
  { city: 'Vladivostok', modes: 'Domestic flight (8h)', tips: 'Far east — always fly. Time zone: Moscow +7h.' },
];

export default function Regional() {
  return (
    <>
      <PageHero eyebrow="Getting Around" title="Moscow to" highlight="Regional Cities"
        subtitle="Reached Moscow. What now? Here’s exactly how to travel from Moscow to your Russian medical university city — by flight, high-speed train, or overnight sleeper."
        breadcrumbs={[{ label: 'Regional Connectivity' }]} />

      <Section eyebrow="Onward Travel" title="From Moscow to" highlight="Your Campus">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cities.map((c, i) => (
            <div key={i} className="bg-white rounded-2xl border border-border p-5">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl bg-brand/10 text-brand flex items-center justify-center"><MapPin className="w-5 h-5" /></div>
                <h4 className="font-serif text-lg font-bold text-primary">{c.city}</h4>
              </div>
              <div className="mt-3 text-xs font-bold text-brand uppercase tracking-wider">Modes</div>
              <div className="text-sm text-foreground mt-1">{c.modes}</div>
              <div className="mt-3 pt-3 border-t border-border text-xs text-muted-foreground italic">{c.tips}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section eyebrow="Modes of Transport" title="Choose Your" highlight="Journey" muted>
        <div className="grid sm:grid-cols-3 gap-5">
          <InfoCard icon={Plane} title="Flights">Best for cities &gt;800 km. Domestic flights from Moscow SVO/DME cover the country in 2–8 hours.</InfoCard>
          <InfoCard icon={Train} title="High-Speed Trains">Sapsan (Moscow-SPb), Strizh (Kazan) — comfortable, punctual, and often cheaper than flights.</InfoCard>
          <InfoCard icon={Bus} title="Sleeper Trains">Overnight sleeper trains save on one night’s hostel. Iconic Russian experience.</InfoCard>
        </div>
      </Section>

      <CTABlock title="Don't stress the arrival" subtitle="Our local Russian team picks you up from Moscow airport and coordinates onward travel to your university." />
    </>
  );
}
